import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import {
    collection,
    doc,
    onSnapshot,
    updateDoc,
    deleteDoc,
    getDocs,
    getDoc
} from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import { Toast } from "../components_root/ToastContext";
import { MdAdd, MdDelete, MdDeleteOutline, MdRemove } from "react-icons/md";
import "./chart.css";

export const seo = {
    title: "Shopping Cart | Add Items & Continue Your Order on aooz",
    description:
        "Easily add items to your shopping cart and continue your order with aooz. Manage products, review selections, and checkout seamlessly for a smooth shopping experience.",
    keywords:
        "shopping cart, add to cart, continue order, online shopping, order management, checkout, cart page, aooz cart, buy online",
    url: "https://aooz.in/cart",
    image: "https://aooz.in/assets/logo.png",
};

// ✅ Guest ID generator
function getGuestId() {
    let guestId = localStorage.getItem("guestId");
    if (!guestId) {
        guestId = "guest_" + Math.random().toString(36).substring(2, 12);
        localStorage.setItem("guestId", guestId);
    }
    return guestId;
}

export default function Chart_root() {
    const { Toastshow } = Toast();
    const navigate = useNavigate();

    const [cartItems, setCartItems] = useState([]);
    const [guestId, setGuestId] = useState(getGuestId());
    const [loading, setLoading] = useState(true);

    // ✅ Detect login and update guestId
    useEffect(() => {
         const sessionToken = Cookies.get("sessiontoken");
         const guid = Cookies.get("guid");
         if (sessionToken && guid) {
             setGuestId(guid);
         }
         else{
             //navigate('/login');
         }
     }, []);

    // ✅ Listen to Firestore cart items and get product details
    useEffect(() => {
        if (!guestId) return;

        const itemsRef = collection(db, "cart_items", guestId, "items");

        const unsubscribe = onSnapshot(
            itemsRef,
            async (snapshot) => {
                const cartList = snapshot.docs.map((doc) => ({
                    uid: doc.id,
                    ...doc.data(),
                }));

                if (cartList.length === 0) {
                    setCartItems([]);
                    setLoading(false);
                    return;
                }

                try {
                    const allProducts = [];

                    for (const item of cartList) {
                        if (!item.productuid) continue;

                        const productRef = doc(db, "products", item.productuid);
                        const productSnap = await getDoc(productRef);
                        if (!productSnap.exists()) continue;

                        const productData = productSnap.data();

                        // Fetch fields subcollection
                        const fieldsSnap = await getDocs(collection(productRef, "fields"));
                        let child = {};
                        fieldsSnap.forEach((fieldDoc) => {
                            const { fieldName, fieldValue } = fieldDoc.data();
                            child[fieldName] = fieldValue;
                        });

                        allProducts.push({ uid: productSnap.id, ...productData, child });
                    }

                    // Merge cart items with product info
                    const mergedData = cartList.map((cartItem) => {
                        const product = allProducts.find((p) => p.uid === cartItem.productuid);
                        return { ...cartItem, product };
                    });

                    setCartItems(mergedData);
                } catch (err) {
                    console.error("Error fetching product info:", err);
                    Toastshow("Failed to load product details.");
                } finally {
                    setLoading(false);
                }
            },
            (error) => {
                console.error("Error fetching cart items:", error);
                Toastshow("Error loading cart items.");
                setLoading(false);
            }
        );

        return () => unsubscribe();
    }, [guestId]);

    // ✅ Update item quantity
    const updateQty = async (uid, change) => {
        try {
            const itemRef = doc(db, "cart_items", guestId, "items", uid);
            const item = cartItems.find((x) => x.uid === uid);
            const newQty = Math.max(1, (item.qty || 1) + change);
            await updateDoc(itemRef, { qty: newQty });

            // Update local state instantly for totalAmount recalculation
            setCartItems((prev) =>
                prev.map((x) => (x.uid === uid ? { ...x, qty: newQty } : x))
            );
        } catch (err) {
            console.error(err);
            Toastshow("Failed to update quantity.");
        }
    };

    // ✅ Remove item
    const removeItem = async (uid) => {
        try {
            await deleteDoc(doc(db, "cart_items", guestId, "items", uid));
            setCartItems((prev) => prev.filter((x) => x.uid !== uid)); // remove locally too
            Toastshow("Item removed from cart.");
        } catch (err) {
            console.error(err);
            Toastshow("Failed to remove item.");
        }
    };

    // ✅ Calculate total
    const totalAmount = cartItems.reduce(
        (sum, item) => sum + ((item.product?.child?.price || 0) * (item.qty || 1)),
        0
    );

    return (
        <div>
            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_roots">
                <div className="container_size">
                    <table>
                        <tr>
                            <td>  <h2 className="text-h1  font-bold mb-4">Cart order</h2></td>
                                 <td width={70}>  <div className="text-h2 mb-4">{cartItems.length} Items </div></td>
                        </tr>
                    </table>
                  

                    {loading ? (
                        <div>Loading your cart...</div>
                    ) : cartItems.length === 0 ? (
                        <div className="empty-cart">Your cart is empty.</div>
                    ) : (
                        <div className="ui-grid-fill">
                            {cartItems.map((row) => (
                                <div key={row.uid} className="ui-items b-1 rounded">
                                    <div className="flex">
                                        <img
                                            src={row.product?.thumbnail || "/assets/logo.png"}
                                            alt={row.product?.title || "Product"}
                                            className="cart-thumb m-1 rounded"
                                        />
                                        <div>
                                            <div className="text-h2 fcap bold">{row.product?.title || "Unnamed product"}</div>
                                            <table>
                                                <tr>
                                                    <td>
                                                        <p className="text-h1 bold">
                                                            ₹{row.product?.child?.price || 0} × {row.qty || 1}
                                                        </p>
                                                    </td>
                                                    <td width={110}>
                                                        <table>
                                                            <tr>
                                                                <td>
                                                                    <MdRemove onClick={() => updateQty(row.uid, -1)} className="icon b-1 p-1 rounded cursor" />
                                                                </td>
                                                                <td> <div className="text-h2 p-1 bold">{row.qty || 1}</div></td>
                                                                <td><MdAdd onClick={() => updateQty(row.uid, +1)} className="icon b-1 p-1 rounded cursor" /></td>
                                                                <td>  <div onClick={() => removeItem(row.uid)} className="button-ui0 p-0 cursor" title="Remove Item">
                                                                    <MdDeleteOutline className="icon" />
                                                                </div></td>
                                                            </tr>

                                                        </table>


                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {cartItems.length > 0 && (
                        <div className="post-container m-top-10">
                            <div className="post_div">
                                <div className="text-h2  p-22">
                                    <a>Total Amount: </a>
                                    <a className="text-h1 bold">₹{totalAmount.toLocaleString()}/-</a>
                                </div>
                            </div>
                            <div className="post_updates p-22">
                                <div
                                    className="button-ui fill center rounded p-22 cursor"
                                    onClick={() => navigate("/checkout")}
                                >
                                    Proceed to Order
                                </div>
                            </div>

                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
